import { Model } from 'app/model/backendmodel';
import { AdapterRegistry } from '../../../adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { CopySink } from 'app/model/pipeline/copysink/copysink';
import { FormatWriteSettingsAdapter, formatWriteSettingsAdapts } from './format-write-settings.adapter';
import { OrcFormatWriteSettings } from 'app/model/pipeline/copysink/format-write-settings/orc-format-write-settings';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(OrcFormatWriteSettings),
    asynchronous: true,
    adapts: {
        ...formatWriteSettingsAdapts
    }
})
export class OrcFormatWriteSettingsAdapter extends FormatWriteSettingsAdapter<
    OrcFormatWriteSettings,
    Model.FormatWriteSettings
> {
    protected override async _toResource(model: OrcFormatWriteSettings): Promise<Model.FormatWriteSettings> {
        const result: Model.FormatWriteSettings = FormatWriteSettingsAdapter.getCommonWriteSettingsProperties(
            Metamodel.modelFor(OrcFormatWriteSettings).name
        );
        FormatWriteSettingsAdapter.toFormatWriteSettingsResource(model, result);
        return result;
    }

    protected override async _toModel(
        resource: Model.FormatWriteSettings,
        copySink: CopySink
    ): Promise<OrcFormatWriteSettings> {
        const result = FormatWriteSettingsAdapter.createWriteSettingsWithCommonProperties(
            OrcFormatWriteSettings.MODEL,
            copySink
        ) as OrcFormatWriteSettings;
        FormatWriteSettingsAdapter.toFormatWriteSettingsModel(resource, result);
        return result;
    }
}
